export default __webpack_public_path__ + "static/media/checked-navy.0e4e28bc.svg";